<page-grid
     #matchingVccGridRef
    [gridConfig]="matchingVccGrid"
    (gridCurrentData)="setItemsSave($event)"
    (gridEvent)="applyUpdate()"
    (gridClickColumn)="openDetailDialog($event)">
        <ng-template #actionItem let-item="item">
          <div class="flexible-content">
            @if(item?.isAmountMatches && !item.userApproved && !item.dateApproved){
            <button mat-icon-button (click)="$event.stopPropagation(); applyRevert(item)" matTooltip="{{item?.revert ? 'Undo' : 'Revert'}}" [matTooltipPosition]="'above'" [disabled]="item?.shouldResolve">
              <mat-icon>
                @if(item?.revert){
                undo
                } @else {
                redo
                }
              </mat-icon>
            </button>

            }
            @if(item?.isAmountMatches){
            @if(!item?.userApproved && !item?.dateApproved){
            <mat-checkbox [checked]="item?.isResolved" [disabled]="!item?.revert" (change)="setResolve(item)" matTooltip="Resolve" [matTooltipPosition]="'below'"></mat-checkbox>
            <mat-slide-toggle [(ngModel)]="item.isEnabled" (change)="handleToggleRecord()">{{item?.isEnabled ? 'ON' : 'OFF'}}</mat-slide-toggle>
            }
            }
          </div>
        </ng-template>
</page-grid>

<ng-template #modalDetailRef let-data>
    <modal-panel id="matching-vcc-detail-viewer-modal" [title]="'Matching Vcc Detail'" (close)="closeDetailDialog()">
        <ng-container id="matching-vcc-detail-viewer-modal-container">
            <matching-vcc-detail-v2 [id]="data"></matching-vcc-detail-v2>
        </ng-container>

        <ng-container id="matching-vcc-detail-viewer-modal-footer-container" modalPanelFooter>
            <div class="modal-footer">
                <button id="matching-vcc-detail-viewer-modal-button" mat-raised-button color="primary" (click)="closeDetailDialog();">Close</button>
            </div>
        </ng-container>
    </modal-panel>
</ng-template>
